export enum PaymentErrors {
	PAYMENT_FAILED = 'Payment Failed',
	PAYMENT_DECLINED = 'Payment Declined',
}
